var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"tituloOnco text-center"},[_c('h1',{staticClass:"etiqueta"},[_vm._v("Seguro MASCOTA SALUD")]),_c('img',{staticClass:"logo-rosa",attrs:{"src":_vm.Rosa,"alt":"Image 1"}}),_c('div',{staticClass:"vertical-line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }